/**
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: valeriaplutino
 * Created: 6/12/21
 */

import {
    withCurrentAssignment,
    WithCurrentAssignmentProps,
} from '@/components/contexts/AssignmentContext/withCurrentAssignment';
import { WorkplanIdProvider } from '@/components/contexts/WorkplanContext/providers';
import WorkplanVersionProvider from '@/components/contexts/VersionContext/WorkplanVersionProvider';
import React from 'react';
import { useParams } from 'react-router-dom';
import DashboardContent from '@/components/pages/dashboard/DashboardContent';
import WorkplanLoader from '@/components/pages/dashboard/WorkplanLoader';

const Dashboard = ({ currentAssignment }: WithCurrentAssignmentProps) => {
    const { workplanId, version } = useParams<{
        workplanId: string;
        version: string;
    }>();

    if (workplanId && version) {
        return (
            <WorkplanIdProvider id={Number(workplanId)}>
                <WorkplanVersionProvider version={Number.parseInt(version)}>
                    <DashboardContent currentAssignment={currentAssignment} />
                </WorkplanVersionProvider>
            </WorkplanIdProvider>
        );
    } else {
        return <WorkplanLoader />;
    }
};

export default withCurrentAssignment(Dashboard);
